import { set } from 'lodash'

export const parseErrorAttributes = attrs =>
  Object.entries(attrs).reduce((res, [key, val]) => {
    set(res, key, val)

    return res
  }, {})
